module.exports = __webpack_public_path__ + "img/Oficina Argentina_BsAs.7e511ca7.jpeg";